module.exports = __webpack_public_path__ + "static/media/SRPF47.93821c77.png";